export const makeArray = <I = any>(obj: I | I[]): I[] => {
  if (Array.isArray(obj)) {
    return obj;
  } else if (obj === undefined || obj === null) {
    return [];
  } else {
    return [obj];
  }
};
